export default {
  profile: "Profil",
  generalInformation: "Allgemeine Informationen",
  notificationSettings: "Benachrichtigungseinstellungen",
};
